import { bool, func } from 'prop-types'
import { PureComponent } from 'react'
import { Button, kuiperClassNames, TextArea } from '@opallabs/kuiper'

import './styles.scss'

export default class AccessRequestForm extends PureComponent {
  static propTypes = {
    accessRequested: bool,
    hasCurrentError: bool,
    onRequestAccess: func,
  }

  static defaultProps = {
    hasCurrentError: false,
  }

  constructor(props) {
    super(props)

    this.state = {
      formIsVisible: false,
      requestMessage: '',
    }
  }

  toggleFormButton() {
    if (!this.state.formIsVisible) {
      return (
        <Button
          className="formToggleButton"
          color="blue"
          label="Request Access"
          onClick={this.onShowForm}
          type="invisible"
        />
      )
    }
    return null
  }

  form() {
    if (this.state.formIsVisible) {
      return (
        <div
          className={kuiperClassNames('accessRequestForm-fields', {
            visible: this.state.formIsVisible,
          })}
        >
          <TextArea
            placeholder="Explain why you need access to this private moment"
            onChange={this.onUpdateRequestMessage}
            theme="light"
            value={this.state.requestMessage}
          />
          <div
            className={kuiperClassNames(
              'accessRequestForm-controls',
              'hasBgColor',
              'nw'
            )}
          >
            <Button
              color="white"
              label="Cancel"
              onClick={this.onCancel}
              type="primary"
            />
            <Button
              color="blue"
              disabled={this.shouldDisableSubmitButton()}
              label="Submit"
              onClick={this.onSubmit}
              type="primary"
            />
          </div>
        </div>
      )
    }

    return null
  }

  onCancel = () => {
    this.setState({
      requestMessage: '',
      formIsVisible: false,
    })
  }

  onShowForm = () => {
    this.setState({
      formIsVisible: true,
    })
  }

  onSubmit = () => {
    this.setState(
      {
        formIsVisible: false,
      },
      this.props.onRequestAccess(this.state.requestMessage)
    )
  }

  onUpdateRequestMessage = (message) => {
    this.setState({
      requestMessage: message,
    })
  }

  shouldDisableSubmitButton() {
    return this.state.requestMessage.length === 0
  }

  render() {
    const { hasCurrentError, accessRequested } = this.props

    if (hasCurrentError) {
      return (
        <span className={kuiperClassNames('accessRequestForm-errorText')}>
          An error occurred requesting access
        </span>
      )
    }
    if (accessRequested) {
      return <span>Access Requested!</span>
    }
    return (
      <div className={kuiperClassNames('accessRequestForm')}>
        {this.toggleFormButton()}
        {this.form()}
      </div>
    )
  }
}
